import React, { useState } from "react";
import {
  Box,
  Typography,
  List,
  ListItemButton,
  ListItemText,
  Paper,
  Divider,
  useTheme,
  ListItemIcon,
} from "@mui/material";
import SettingsIcon from "@mui/icons-material/Settings";
import BuildIcon from "@mui/icons-material/Build";
import EmailIcon from "@mui/icons-material/Email";
import SecurityIcon from "@mui/icons-material/Security";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import Header from "../components/Header";
import { PaymentOutlined, WhatsApp } from "@mui/icons-material";
import LockIcon from "@mui/icons-material/Lock";
import ServiceManagement from "../components/SystemSetting/ServiceManagement";
import OTPSettings from "../components/SystemSetting/OTPSettings";

const settingSections = [
  {
    key: "general",
    label: "General",
    icon: <SettingsIcon />,
  },
  {
    key: "service",
    label: "Service Management",
    icon: <BuildIcon />,
  },
  {
    key: "whatsapp",
    label: "WhatsApp",
    icon: <WhatsApp />,
  },
  {
    key: "payment",
    label: "Payment",
    icon: <PaymentOutlined />,
  },
  {
    key: "otp",
    label: "OTP",
    icon: <LockIcon />,
  },
];

const SystemSettingPage = () => {
  const theme = useTheme();
  const [selectedSection, setSelectedSection] = useState("service"); // Default to Service Management

  return (
    <Box className="main-container mt-4">
      <Header title="System Settings" />
      <Box display={"flex"} sx={{ mt: 5 }}>
        <Paper
          elevation={2}
          sx={{
            minWidth: 240,
            p: 0,
            borderRadius: 2,
            alignSelf: "flex-start",
          }}
        >
          <List disablePadding>
            {settingSections.map((sec) => (
              <React.Fragment key={sec.key}>
                <ListItemButton
                  selected={selectedSection === sec.key}
                  onClick={() => setSelectedSection(sec.key)}
                  sx={{
                    borderLeft:
                      selectedSection === sec.key
                        ? `4px solid ${theme.palette.primary.main}`
                        : "4px solid transparent",
                    bgcolor:
                      selectedSection === sec.key
                        ? "action.selected"
                        : "background.paper",
                  }}
                >
                  <ListItemIcon sx={{ minWidth: 36 }}>{sec.icon}</ListItemIcon>
                  <ListItemText primary={sec.label} />
                  <ArrowForwardIosIcon
                    fontSize="small"
                    color="disabled"
                    sx={{ ml: 1 }}
                  />
                </ListItemButton>
                <Divider />
              </React.Fragment>
            ))}
          </List>
        </Paper>

        {/* Main Content Area */}
        <Box sx={{ flex: 1, minHeight: 480 }}>
          {selectedSection === "general" && (
            <Paper sx={{ p: 4, borderRadius: 2, ml: 1, height: "70vh" }}>
              <Box display="flex" gap={3}>
                <SettingsIcon />
                <Typography variant="h5" gutterBottom>
                  General Settings
                </Typography>
              </Box>
            </Paper>
          )}

          {selectedSection === "service" && (
            <Paper sx={{ p: 4, borderRadius: 2, ml: 1, height: "70vh" }}>
              <Box display="flex" gap={3}>
                <BuildIcon />
                <Typography variant="h5" gutterBottom>
                  Service Management
                </Typography>
              </Box>
              <ServiceManagement/>
            </Paper>
          )}

          {selectedSection === "whatsapp" && (
            <Paper sx={{ p: 4, borderRadius: 2, ml: 1, height: "70vh" }}>
              <Box display="flex" gap={3}>
                <WhatsApp />
                <Typography variant="h5" gutterBottom>
                  WhatsApp Integration
                </Typography>
              </Box>
            </Paper>
          )}

          {selectedSection === "payment" && (
            <Paper sx={{ p: 4, borderRadius: 2, ml: 1, height: "70vh" }}>
              <Box display={"flex"} gap={3}>
                <PaymentOutlined />
                <Typography variant="h5" gutterBottom>
                  Cutsomize Payment integration
                </Typography>
              </Box>
            </Paper>
          )}

          {selectedSection === "otp" && (
            <Paper sx={{ p: 4, borderRadius: 2, ml: 1, minHeight: "70vh" }}>
              <Box display="flex" gap={3} mb={3}>
                <LockIcon />
                <Typography variant="h5" gutterBottom>
                  OTP Settings
                </Typography>
              </Box>
              <OTPSettings />
            </Paper>
          )}
        </Box>
      </Box>
    </Box>
  );
};

export default SystemSettingPage;
